import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles(theme => ({
    close: {
        padding: theme.spacing(0.5)
    }
}));
function Notification(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const { message, action, onDismiss, forceOpen } = props;
    function handleOpen() {
        setOpen(true);
    }
    function handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        onDismiss();
        setOpen(false);
    }
    return (React.createElement("div", null,
        React.createElement(Snackbar, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, open: open || forceOpen, autoHideDuration: 6000, onClose: handleClose, message: React.createElement("span", { id: 'message-id' }, message), action: [action,
                React.createElement(IconButton, { key: 'close', color: 'inherit', className: classes.close, onClick: handleClose },
                    React.createElement(CloseIcon, null))
            ] })));
}
export default Notification;
//# sourceMappingURL=Notification.js.map